<template>
<div>
        <!-- <v-container fluid>
          <v-layout row wrap> -->
            <!-- <v-flex xs12 sm12> -->
              <!-- {{$attrs}}
              {{!('disabled' in $attrs) || ('readonly' in $attrs)}} -->
              <!-- {{rules[0](value) }} -->
              <!-- {{this.$refs.textvaridate}} -->
              <!-- {{pError}} -->
              <!-- {{$refs.textvaridate['error-messages']}} -->
              <!-- <v-text-field 
                v-show="true" ref="textvaridate" 
                v-model="person" 
                :rules="rules">
              </v-text-field> -->
              <v-autocomplete
                ref="arrPerson"
                v-bind="$attrs"
                v-model="e11"
                :search-input.sync="e_input"
                @click:append="test"
                :multiple="true"
                :small-chips="true"
                :deletable-chips="true"
                :auto-select-first="true"
                :dense="$attrs.text_filled||true" 
                :filled="$attrs.text_filled||true"                
                :items="persons"
                item-text="EmpName"
                item-value="EmpCode"
                :menu-props="mProp"
                :hint="e_input"
                :clearable="!(('disabled' in $attrs) || ('readonly' in $attrs) )"
                :rules="rules"
              >
                <!-- :error="pError" -->
                <!-- :clearable="true" -->
                <!-- :error="componentError" -->
                <!-- :error="!$refs.textvaridate.valid" -->
                <!-- :error-messages="$refs.textvaridate.rules[0]()" -->
              <!-- <template #selection="{ item }">
                  <v-chip 
                  small
                  close
                  close-icon="mdi-close-outline"
                  color="white--text indigo darken-4">{{item.EmpName}}</v-chip>
                </template> -->
              </v-autocomplete>
            <!-- </v-flex> -->
          <!-- </v-layout>
        </v-container> -->
     
</div>
</template>
<script>
  import bookServ from '@/store/api/services/bookService'
  export default {
    props: {
      roles: {
        type: Array,
        default: function() {
          return []
        }
      },
      value: {
        type: String,
        default: ''
      },
      filter: {
        type: String,
        default: ''
      },
      empCode: {
        type: String,
        default: ''
      },
      single: {
        type: Boolean,
        default: false
      },
      rules: {
          type: Array,
          required: false
      },
      // label: {
      //   type: String,
      //   default: ''
      // },
      // readonly: {
      //   type: Boolean,
      //   default: false
      // }
    },
    mounted: function () {
      this.formatValue()
      this.$nextTick(function () {
        // console.log('created', this.$route.params.id)
        // if (this.$store.state.users.empAll.length === 0){
        //   // console.log('inputperson dispacth getEmpAll')
        //   this.people = this.$store.state.dispacth('getEmpAll')
        // } else {
        //   // console.log('inputperson users.empAll')
        // }
        // this.people = this.$store.state.users.empAll
        let peoplefilter = this.$store.state.users.empAll
        // console.log('this.filter', this.filter)
        // console.log('peoplefilter', peoplefilter)
        if (!!this.filter && peoplefilter.length > 0) {
          // console.log('inputperson filter',this.people)
          this.people = peoplefilter.filter((e) => {
            if( eval(this.filter) ) {
              // filter = 'e.DepCode === "สารสนเทศ"'
              // filter = 'e.DivName === "ฝ่ายบริหาร"'
              // console.log(this.filter,eval('e.DepCode'))
              return e
            }
          })
        } else {
          this.people = peoplefilter
        }
 
        if (this.roles.length > 0){
          peoplefilter =  this.people.filter((e)=>{
            if(!e.Role) return false
            const roles = this.roles
            const permissionRoles = e.Role.split(',')
            
            return roles.some(role => {
              return permissionRoles.includes(role)
            })
          })
          // peoplefilter.push({ EmpCode: '0000', EmpName: 'ไม่ระบุ' })
          this.people =  peoplefilter
        }else{
          let peoplefilter =  this.people
          // peoplefilter.push({ EmpCode: '0000', EmpName: 'ไม่ระบุ' })
          this.people =  peoplefilter
        }
        // bookServ.getEmp({ filter: this.filter, empCode: this.empCode })
        // .then((response) => {
        //   console.log('inputperson getEmp',response.data)
        //   this.people = response.data.data
        //   if (this.filter === '') {
        //     localStorage.setItem('EmpAll', JSON.stringify(this.people))
        //   }
        // })
        // .catch((error) => {
        //   console.error(error)
        // })
      })
    },
    watch: {
      filter() {
        // console.log('filter change')

        if (this.filter !== '') {
          // console.log('inputperson filter',this.people)
          this.people = this.$store.state.users.empAll.filter((e) => {
            if( eval(this.filter) ) {
              // filter = 'e.DepCode === "สารสนเทศ"'
              // filter = 'e.DivName === "ฝ่ายบริหาร"'
              // console.log(this.filter,eval('e.DepCode'))
              return e
            }
          })
        }else{
          // console.log('inputperson not filter')
          this.people = this.$store.state.users.empAll
        }
        // console.log('roles',this.roles)
        if (this.roles.length > 0){
          let peoplefilter =  this.people.filter((e)=>{
            if(!e.Role) return false
            const roles = this.roles
            const permissionRoles = e.Role.split(',')
            
            return roles.some(role => {
              return permissionRoles.includes(role)
            })
          })
          // peoplefilter.push({ EmpCode: '0000', EmpName: 'ไม่ระบุ' })
          this.people =  peoplefilter
        }else{
          let peoplefilter =  this.people
          // peoplefilter.push({ EmpCode: '0000', EmpName: 'ไม่ระบุ' })
          this.people =  peoplefilter
        }
      },
      value (v,oldv) {
        console.log('value', v)
        console.log('oldvalue', oldv)

        if (this.value) {
          // console.log('input value 1', this.value)
          // console.log('input e11', this.e11)
          var v
          if (this.value !== '') {
            v = this.value.trim().split(',').map(m=> {m.trim(); return m})
          } else {
            v = []
          }
          // console.log('input v ', v)
          if(this.single && v.length > 1) {
            v.shift()
          }
          if (v !== this.e11) {
            this.e11 = v
            this.$emit('input', this.e11.toString())
          }
        } else {
          this.e11 = []
          this.$emit('input', '')
        }
        this.e_input = ''
        if(this.single && this.e11.length > 0) {
          this.$refs.arrPerson.blur()
          this.$refs.arrPerson.focus()
        }
        if(v !== oldv){
          let EmpCode = this.e11.toString()
          let EmpName = this.$options.filters.empFullName(EmpCode, this.people, '')
          this.$emit('change', {EmpName:EmpName,EmpCode:EmpCode})
        }
        
      },
      e11 () {
          // console.log('e11', this.e11)
          this.person = this.e11.toString()
          // this.$refs.arrPerson.error = !this.$refs.textvaridate.valid
          this.pError = !!this.componentError
          this.$emit('input', this.person)
      }
    },
    computed: {
      persons: function() {
        return this.people
      },
      componentError() {
        try{
          let r = this.$refs.textvaridate.valid
          return !!r
        }catch(e){
          return false
        }
      },
    },
    methods: {
      person_error(e) {
        console.log('person_error', e)
      },
      test: function() {
        // console.log('update:search-input')
      },
      formatValue: function () {
        // console.log('label', this.label)
        // console.log('formatValue-01', this.value)
        if (this.value) {
          this.e11 = this.value.trim().split(',').map(m=> {m.trim(); return m})
        } else {
          this.e11 = []
        }

        // this.formatted = this.Date2Text(this.value)
        // this.$refs.Input.value = this.Date2Text(this.value)
        // console.log('formatValue-03  ok', this.e11)
      },
      getName: function (code) {
        return this.people.filter((p) => {
          if (p.code === code) return p
        })[0]
      }

    },
    data () {
      return {
        pError:false,
        mProp:{
          maxHeight: 250,
        },
        person: '',
        e11: [],
        e_input:'',
        picPath: '/static/doc-images/lists/',
        people: [
          // { header: 'Group 1' },
          // { EmpCode: '0090', EmpName: 'Sandra Adams', DepName: 'DepName 1', avatar: srcs[1] },
          // { EmpCode: '0091', EmpName: 'Ali Connors', DepName: 'DepName 1', avatar: srcs[2] },
          // { EmpCode: '0092', EmpName: 'Trevor Hansen', DepName: 'DepName 1', avatar: srcs[3] },
          // { EmpCode: '0093', EmpName: 'Tucker Smith', DepName: 'DepName 1', avatar: srcs[2] },
          // { divider: true },
          // { header: 'DepName 2' },
          // { EmpCode: '0094', EmpName: 'Britta Holt', DepName: 'DepName 2', avatar: srcs[4] },
          // { EmpCode: '0095', EmpName: 'Jane Smith ', DepName: 'DepName 2', avatar: srcs[5] },
          // { EmpCode: '0096', EmpName: 'John Smith', DepName: 'DepName 2', avatar: srcs[1] },
          // { EmpCode: '0097', EmpName: 'Sandra Williams', DepName: 'DepName 2', avatar: srcs[3] }
        ]
      }
    }
  }
</script>
<style scoped>
  /* .v-text-field {
    margin-top: 2px;
    padding-top: 4px;
  } */

  /* .list__tile .list__tile--active a {
    color:#fff;
    background-color: blue;
  }
  div .list__tile--active {
    background-color: blue;
  } */
  /* list__tile--avatar list__tile--active list__tile--highlighted" */
</style>
